<template>
	<div class="branch-container flex-direction">
		<div class="small-title">
			<el-breadcrumb class="breadcrumb">
				<el-breadcrumb-item :to="{ path: '/ordermanage' }">订单管理</el-breadcrumb-item>
				<el-breadcrumb-item>订单详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div>{{ detail.title.name }}</div>
			<div class="order-details-parma">
				<div class="details-parma-shelf">
					<div class="parma-shelf-info">
						<div class="parma-shelf-title">订单编号：</div>
						<div class="parma-shelf-value">
							{{ detail.title.order_name }}
						</div>
					</div>
					<div class="parma-shelf-info">
						<div class="parma-shelf-title">下单时间：</div>
						<div class="parma-shelf-value">
							{{ detail.title.create_time ? detail.title.create_time : '-' }}
						</div>
					</div>
					<!-- <div class="parma-shelf-info" v-show="detail.title.pay_time">
						<div class="parma-shelf-title">付款时间：</div>
						<div class="parma-shelf-value">
							{{ detail.title.pay_time ? detail.title.pay_time : '-' }}
						</div>
					</div> -->
					<div class="parma-shelf-info">
						<div class="parma-shelf-title">交付日期：</div>
						<div class="parma-shelf-value">
							{{ detail.title.submit_case_time ? detail.title.submit_case_time : '-' }}
						</div>
					</div>
				</div>
				<div class="details-parma-shelf">
					<div class="parma-shelf-info">
						<div class="parma-shelf-title">状态：</div>
						<div class="parma-shelf-value bold">
							{{ detail.title.order_status }}
						</div>
						<div class="time-last" v-if="detail.title && detail.title.pay_down_time > 0">
							<count-down @finish="finishCountDown" :time="detail.title.pay_down_time" /><span
								>后关闭</span
							>
						</div>
					</div>
					<!-- <div class="parma-shelf-info">
						<div class="parma-shelf-title">
							{{
								detail.title.order_status == '待分配' ||
								detail.title.order_status == '待接单' ||
								detail.title.order_status == '待报价'
									? '预估订单金额：'
									: '支付订单金额：'
							}}
						</div>
						<div class="parma-shelf-value bold">
							{{ detail.title.price ? detail.title.price : '-' }}
						</div>
					</div> -->
				</div>
				<div class="details-parma-shelf">
					<div class="btn-group">
						<div v-for="(item, index) in detail.permissions" :key="index">
							<el-button
								class="details-parma-btn"
								:class="{
									plain: detail.permissions.length > 1 && index == 0,
								}"
								size="small"
								type="danger"
								@click="permissions[item].trigger"
								v-if="item != 40"
							>
								{{ permissions[item].name }}
							</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- title end -->
		<div class="detail-content">
			<!-- 撤单信息 -->
			<div class="detail-content-left">
				<div
					class="detail-pictrue-info refund-info"
					v-if="detail.refund_info && detail.refund_info.refund_amount"
				>
					<div class="detail-content-title">撤单信息</div>
					<div class="content-info-text">
						<div class="text-item">
							<!-- <div class="text-item-cell">
								<div>
									撤单订单金额:
									<span>{{ detail.refund_info.num }}</span>
								</div>
							</div>
							<div class="text-item-cell" v-if="detail.refund_info.refund_score">
								<div>
									撤单积分:
									<span>{{ detail.refund_info.refund_score }}</span>
								</div>
							</div>
							<div class="text-item-cell" v-if="detail.refund_info.refund_price">
								<div>
									撤单余额:
									<span>{{ detail.refund_info.refund_price }}</span>
								</div>
							</div>
							<div class="text-item-cell" v-if="detail.refund_info.num">
								<div>
									撤单金额:
									<span>{{ detail.refund_info.refund_amount }}</span>
								</div>
							</div> -->
							<div class="text-item-cell" v-if="detail.refund_info.remark">
								<div>
									撤单信息备注:
									<span>{{ detail.refund_info.remark }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="audit-box" v-if="detail.refused.type && detail.refused.type != 12">
					<div class="detail-content-title">
						{{ detail.refused.type == 10 ? '审核结果' : ' 撤单信息' }}
					</div>
					<div class="failure-content">
						<img src="../assets/icon/red_close.png" alt="拒絕" />
						<div>
							<div class="check-infor">
								<p class="check-type">
									{{ detail.refused.type == 10 ? '不通过' : '撤单申请不通过' }}
								</p>
								<p class="check-time">
									<span v-if="detail.refused.type == 10">审核人：{{ detail.refused.name }} </span
									>{{ detail.refused.time }}
								</p>
							</div>
							<h6>
								{{ detail.refused.remark }}
							</h6>
						</div>
					</div>
				</div>
				<div class="audit-box" v-if="detail.refused.type && detail.refused.type == 12">
					<div class="detail-content-title">订单取消</div>
					<div class="failure-content">
						<img src="../assets/icon/red_close.png" alt="取消" />
						<div>
							<div class="check-infor">
								<p class="check-type">取消原因</p>
								<p class="check-time">
									<span>取消人：{{ detail.refused.name }} </span>{{ detail.refused.time }}
								</p>
							</div>
							<h6>
								{{ detail.refused.remark.replace('其他', '其他；') }}
							</h6>
						</div>
					</div>
				</div>
				<div class="detail-content-info">
					<div class="detail-content-title">订单信息</div>
					<div class="content-info-text">
						<div class="info-text-group">
							<div class="title">申请人信息</div>
							<div class="text-item">
								<div class="text-item-cell">
									<div>
										申请人:
										<span>{{ detail.order_info.order_apply_name }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										公司信息: <span>{{ detail.order_info.order_company }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										手机号: <span>{{ detail.order_info.order_phone }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										邮箱: <span>{{ detail.order_info.order_email }}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="info-text-group">
							<div class="title">项目信息</div>
							<div class="text-item">
								<div class="text-item-cell">
									<div>
										项目来源:
										<span>{{ detail.crm_order_type == 1 ? detail.crm_order_type_sub===2?'CRM线索':'CRM商机' : '其他' }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										项目业态:
										<span>{{ detail.order_info.order_business }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										项目名称:
										<span>{{ detail.order_info.order_pro_name || '-' }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										相关项目:
										<span>{{ detail.order_info.order_is_dian || '-' }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										设计面积:
										<span>{{ detail.order_info.order_area || '0' }}㎡</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										指定产品:
										<span>{{ detail.order_info.order_assign_pro || '-' }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										项目等级:
										<span>{{ detail.order_info.crm_project_level || '-' }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										项目类型:
										<span>{{
											detail.order_info.crm_project_type == 1
												? '战略客户'
												: detail.order_info.crm_project_type == 2
												? '单体项目'
												: '-'
										}}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										客户等级:
										<span>{{ detail.order_info.customer_level || '-' }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div class="flex_box">
										<p class="p1">备注:</p>
										<p class="p2">
											<span>{{ detail.order_info.order_pro_remark || '-' }}</span>
										</p>
									</div>
								</div>
							</div>
						</div>
						<div class="info-text-group">
							<div class="title">需求信息</div>
							<div class="text-item">
								<!-- <div class="text-item-cell w-100">
                  需求项：{{detail.order_info.order_require_design}}
                </div> -->
								<div
									class="text-item-cell"
									:key="index"
									v-for="(item, index) in detail_order_require_details"
								>
									<div v-if="item.value.length > 0" class="flex_box">
										<!-- {{ item.name }}:
                    <span>{{ item.value }};</span> -->
										<p class="p1">{{ item.name }}:</p>
										<p class="p2">
											<span>{{ item.value }};</span>
										</p>
									</div>
									<div v-else>{{ item.name }};</div>
								</div>
								<!-- <div
                  class="text-item-cell"
                  v-if="
                    detail.order_info.order_require_time && 
                    detail.order_info.order_require_time !== '-'
                  "
                >  -->
								<!-- <div>
                    需求时间:
                    <span>{{
                      detail.order_info.order_require_time || "-"
                    }}</span>
                  </div> -->
								<!-- </div> -->

								<div class="text-item-cell egress_time_address_box">
									<div
										class="text-item-cell"
										v-if="
											detail.order_info.order_dian_time && detail.order_info.order_dian_time != '-'
										"
									>
										外出时间:
										<span>{{ detail.order_info.order_dian_time }}</span>
									</div>
									<div
										class="text-item-cell flex_box"
										v-if="
											detail.order_info.order_dian_address &&
											detail.order_info.order_dian_address != '-'
										"
									>
										<p class="p1">外出地址:</p>
										<p class="p2">
											<span>{{ detail.order_info.order_dian_address }}</span>
										</p>
									</div>
								</div>

								<!-- <div class="text-item-cell"
                  v-if="detail.order_info.order_dian_time"
                >
                  外出时间:
                  <span>{{
                    detail.order_info.order_dian_time || "-"
                  }}</span>
                </div>
                <div class="text-item-cell"
                  v-if="detail.order_info.order_dian_address"
                >
                  外出地址:
                  <span>{{
                    detail.order_info.order_dian_address || "-"
                  }}</span>
                </div> -->
							</div>
						</div>
						<div class="info-text-group" v-if="detail.order_info && detail.order_info.real_name">
							<div class="title">设计师信息</div>
							<div class="text-item">
								<div class="text-item-cell">
									<div>
										主责设计师:
										<span>{{ detail.order_info.real_name }}</span>
									</div>
								</div>
								<div class="text-item-cell">
									<div>
										主责设计师手机号:
										<span>{{ detail.order_info.mobile }}</span>
									</div>
								</div>
								<div class="text-item-cell" v-if="detail.order_info.child_real_name">
									<div>
										协助设计师:
										<span>{{ detail.order_info.child_real_name }}</span>
									</div>
								</div>
								<div class="text-item-cell" v-if="detail.order_info.child_mobile">
									<div>
										协助设计师手机号:
										<span>{{ detail.order_info.child_mobile }}</span>
									</div>
								</div>
							</div>
						</div>
						<div
							class="info-text-group"
							v-if="detail.order_info.price_info && detail.order_info.price_info.order_price"
						>
							<div class="title">报价信息</div>
							<div class="text-item">
								<div class="text-item-cell">
									<div>
										订单金额:
										<span>{{ detail.order_info.price_info.order_price }}</span>
									</div>
								</div>
								<div class="text-item-cell" v-if="detail.order_info.price_info.pay_score">
									<div>
										支付积分:
										<span>{{ detail.order_info.price_info.pay_score }}</span>
									</div>
								</div>
								<div class="text-item-cell" v-if="detail.order_info.price_info.pay_price">
									<div>
										支付余额:
										<span>{{ detail.order_info.price_info.pay_price }}</span>
									</div>
								</div>
								<div class="text-item-cell" v-if="detail.order_info.price_info.pay_amount">
									<div>
										实付金额:
										<span>{{ detail.order_info.price_info.pay_amount }}</span>
									</div>
								</div>
								<div class="text-item-cell" v-if="detail.order_info.price_info.order_require_time">
									<div>
										交付时间:
										<span>{{ detail.order_info.price_info.order_require_time }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="detail-pictrue-info"
					v-if="
						detail.design_info &&
						(detail.design_info.require_imgs.length > 0 || detail.design_info.plan_imgs.length > 0)
					"
				>
					<div class="detail-content-title">
						图纸信息
						<div class="download-pictrue">
							<el-button size="medium" type="danger" class="down-btn" @click="onDownLoad(1)"
								>下载全部图纸</el-button
							>
						</div>
					</div>
					<div class="content-info-text">
						<div class="segmentation">
							<div
								class="info-text-group grouping"
								v-if="detail.design_info.require_imgs.length > 0"
							>
								<div class="title">客户图纸</div>
								<div class="text-item">
									<div
										class="text-item-cell"
										v-for="(item, index) in detail.design_info.require_imgs"
										:key="index"
									>
										<div>
											{{ index + 1 }}.
											<span>{{ item.name }}</span>
											<!-- <span class="btn_box"><a :href="item.url" download>下载</a></span> -->
											<span class="btn_box" v-if="item.url" @click="downloadItem2(item, item.name)"
												>下载</span
											>
										</div>
									</div>
								</div>
							</div>
							<div class="info-text-group grouping" v-if="detail.design_info.plan_imgs.length > 0">
								<div class="title">设计师图纸</div>
								<div class="text-item">
									<div
										class="text-item-cell"
										v-for="(item, index) in detail.design_info.plan_imgs"
										:key="index"
									>
										<div>
											{{ index + 1 }}.
											<span>{{ item.name }}</span>
											<span class="btn_box" v-if="item.url" @click="downloadItem2(item, item.name)"
												>下载</span
											>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="info-text-group top-margin" v-show="detail.order_info.project_instruction">
							<div class="title">方案说明</div>
							<div class="text-other">
								<div class="text-item-cell">
									<div>
										<span>{{ detail.order_info.project_instruction }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="detail-pictrue-info" v-if="detail.comment && detail.comment.star">
					<div class="detail-content-title">评价信息</div>
					<div class="content-info-text segmentation">
						<div class="score-shelf">
							<div class="score-count">项目响应与交付时效</div>
							<div class="score-star">
								<el-rate v-model="scoreStar" disabled class="el-scorestar"></el-rate>
							</div>
							<div class="score-count">方案专业与品质评价</div>
							<div class="score-star">
								<el-rate v-model="scoreStar7" disabled class="el-scorestar"></el-rate>
							</div>
							<div class="score-count">设计师积极性与协作度</div>
							<div class="score-star">
								<el-rate v-model="scoreStar8" disabled class="el-scorestar"></el-rate>
							</div>
						</div>
						<div class="score-desc">
							<div class="time">{{ detail.comment.time }}</div>
							<div class="content">
								{{ detail.comment.remark }}
							</div>
						</div>
					</div>
				</div>
				<div class="detail-pictrue-info" v-if="detail.invoice && detail.invoice.base_create_time">
					<div class="detail-content-title">
						开票信息
						<div class="download-pictrue">
							<el-button size="medium" type="danger" class="down-btn" @click="onDownLoad(2)"
								>下载发票</el-button
							>
						</div>
					</div>
					<div class="content-info-text">
						<div class="three-group">
							<div class="three-group-item">
								<div class="text-item">
									<div class="text-item-cell">
										<div>
											申请时间:
											<span>{{ detail.invoice.base_create_time }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											开票时间:
											<span>{{ detail.invoice.user_check_time }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											开票总额: <span>{{ detail.invoice.user_parice }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											发票类型: <span>{{ detail.invoice.user_tax_type }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											公司名称: <span>{{ detail.invoice.user_name }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											纳税人识别号:
											<span>{{ detail.invoice.user_tax_no }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											收件邮箱: <span>{{ detail.invoice.user_mail }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											开户行:
											<span>{{ detail.invoice.user_company_card }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											银行账号:
											<span>{{ detail.invoice.user_company_card }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											联系电话:
											<span>{{ detail.invoice.user_post_phone }}</span>
										</div>
									</div>
									<div class="text-item-cell">
										<div>
											地址:
											<span>{{ detail.invoice.user_post_address }}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="three-group-item">
								<div class="text-item">
									<div class="text-item-cell">
										<div>
											发票附件:
											<div class="invoice-img">
												<img
													:src="detail.invoice.user_tax"
													v-if="detail.invoice.suffix != 'pdf'"
													alt=""
												/>
												<pdf ref="pdf" v-else :src="detail.invoice.user_tax" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="detail-pictrue-info" v-if="additionalData">
					<div class="detail-content-title">
						补充说明
						<div class="download-pictrue">
							<el-button size="medium" @click="downAllAdditional" type="danger" class="down-btn"
								>下载文件</el-button
							>
						</div>
					</div>
					<div class="content-info-text">
						<div class="info-text-group">
							<div class="title">说明内容</div>
							<div class="text-other">
								<el-input
									class="form-input address"
									type="textarea"
									placeholder="请输入补充说明内容"
									v-model="additionalNotes"
									:autosize="{ minRows: 1, maxRows: 4 }"
									maxlength="200"
									show-word-limit
									resize="none"
									v-if="detail.is_design"
								>
								</el-input>
								<div style="white-space: pre-wrap;" v-else>{{ additionalNotes }}</div>
								<div class="title additional-top-margin">说明文件</div>

								<el-upload
									class="upload-demo"
									:limit="20"
									:multiple="true"
									:file-list="additionalList"
									action=""
									:show-file-list="false"
									:before-upload="onBeforeUploadAdditional"
									:auto-upload="false"
									:on-change="uploadAdditional"
									style="display: flex; align-items: center"
									v-if="detail.is_design"
								>
									<div class="add-additional">
										<i class="el-icon-plus add-icon"></i>
										添加文件
									</div>
								</el-upload>

								<div class="additional-content">
									<div class="additional-item" v-for="(item, index) in additionalList" :key="index">
										<div class="name" @click="downAdditional(item, item.name)">
											{{ item.name }}
										</div>

										<el-popconfirm title="是否删除该文件" @confirm="removeAdditional(index, item)" v-if="detail.is_design">
											<span slot="reference">删除</span>
										</el-popconfirm>
									</div>
								</div>
								<el-button
									size="medium"
									type="danger"
									class="additional-btn"
									@click="saveAdditional"
									v-if="detail.is_design"
									>保存</el-button
								>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 订单日志 -->
			<div class="detail-content-right">
				<div class="detail-content-title">订单日志</div>
				<div class="content-info-text">
					<div class="timestamp">
						<el-timeline :reverse="reverse">
							<el-timeline-item
								placement="top"
								v-for="(activity, index) in detail.order_logs"
								:key="index"
								:timestamp="activity.time"
							>
								{{ activity.title }}
								<div v-if="activity.status">
									<div v-html="activity.status_text || activity.status"></div>
								</div>
								<div class="timestamp-remark" v-if="activity.remark">
									{{ activity.remark }}
								</div>
								<div class="timestamp-file" v-if="activity.files.length > 0">
									<div class="file-name" v-for="(item, index) in activity.files" :key="index">
										{{ item }}
									</div>
								</div>
							</el-timeline-item>
						</el-timeline>
					</div>
				</div>
			</div>
		</div>

		<order-operation
			@getDetails="getDetails"
			@changParams="changParams"
			ref="child"
			:popType="popType"
		></order-operation>
		<!-- <down-zip ref="downzip" :list="[]" urlName="url" imgName="name"></down-zip> -->

		<!-- 单文件下载 -->
		<single-file-download ref="singleFileDownload"></single-file-download>
	</div>
</template>

<script>
	import pdf from 'vue-pdf';
	import {
		$orderOrderDetail,
		$uploadOnlySplitUpload,
		$uploadOnlySplitOn,
		$get_order_mi,
		$get_order_mi_add,
	} from '@/api';
	import CountDown from 'vant/lib/count-down';
	import 'vant/lib/count-down/style';
	import orderOperation from '../components/orderOperation.vue';
	import singleFileDownload from '../components/singleFileDownload.vue';
	import downZip from '../components/downLoadZip.vue';
	// import axios from "axios";
	// import JSZip from "jszip";
	// // eslint-disable-next-line no-unused-vars
	import FileSaver from 'file-saver';

	export default {
		components: { pdf, orderOperation, downZip, singleFileDownload, CountDown },
		computed: {},
		watch: {},
		data() {
			return {
				// 可上传后缀
				suffix_text: [
					'jpg',
					'jpeg',
					'gif',
					'png',
					'bmp',
					'pdf',
					'tif',
					'doc',
					'docx',
					'xls',
					'xlsx',
					'txt',
					'rar',
					'zip',
					'skp',
					'max',
					'dwg',
					'dxf',
					'gz',
					'ppt',
					'pptx',
				],
				isdownload: false,
				clickAloneTimer: null,
				clickAllTimer: null,
				reverse: true,
				popType: 0, //1分配主责设计师 2拒绝分配 3订单报价 4支付成功 5上传方案 6评价方案 7分配协助设计师 8取消订单 9审核不通过 修改方案 10审核方案 11验收方案 12 支付报价 新增
				activities: ['', '通过', '不通过'],
				scoreStar: 4, // 项目响应与交付时效
				scoreStar7: 4, // 方案专业与品质评价
				scoreStar8: 4, // 设计师积极性与协作度
				permissions: {
					39: {
						name: '取消',
						trigger: (item) => {
							this.popType = 8;
						},
					},
					40: {
						name: '详情',
						trigger: (item) => {
							this.$router.push({
								path: '/orderdetails',
								query: { id: window.btoa(item.id) },
							});
						},
					},
					41: {
						name: '支付',
						trigger: () => {
							this.popType = 12;
							this.$refs.child.postOrderPayInfo();
						},
					},
					42: {
						name: '验收',
						trigger: () => {
							this.popType = 11;
							this.$refs.child.getPlanList();
						},
					},
					43: {
						name: '评价',
						trigger: () => {
							this.popType = 6;
						},
					},
					44: {
						name: '确定报价',
						trigger: () => {
							this.$refs.child.postFirmPrice();
						},
					},
					45: {
						name: '审核',
						trigger: () => {
							this.popType = 10;
							this.$refs.child.getPlanList();
						},
					},
					46: {
						name: '分配',
						trigger: () => {
							this.$refs.child.getOrderDesignList(1, 1);
						},
					},
					47: {
						name: '再次分配',
						trigger: (item) => {
							this.$refs.child.getOrderDesignList(1, 1);
						},
					},
					48: {
						name: '分配协助',
						trigger: () => {
							this.$refs.child.getOrderDesignList(7, 1);
						},
					},
					49: {
						name: '拒绝协助',
						trigger: () => {
							this.popType = 13;
						},
					},
					50: {
						name: '接收协助',
						trigger: () => {
							this.$refs.child.agreeAllocation(2);
						},
					},
					51: {
						name: '拒绝分配',
						trigger: () => {
							this.popType = 2;
						},
					},
					52: {
						name: '接受分配',
						trigger: () => {
							this.$refs.child.agreeAllocation(1);
						},
					},
					53: {
						name: '申请协助',
						trigger: () => {
							this.$refs.child.postRrequestAssist();
						},
					},
					54: {
						name: '上传方案',
						trigger: () => {
							this.popType = 5;
							this.$refs.child.getPlanList();
						},
					},
					55: {
						name: '修改',
						trigger: () => {
							this.popType = 9;
							this.$refs.child.postPlanEdit();
						},
					},
					56: {
						name: '订单调整',
						trigger: () => {
							this.popType = 3;
							this.$refs.child.getReportPrice();
						},
					},
					57: {
						name: '继续设计',
						trigger: () => {
							this.$refs.child.continueDesign();
						},
					},
					58: {
						name: '撤单',
						trigger: () => {
							this.popType = 14;
							this.$refs.child.postOrderPayInfo();
						},
					},
					60:{
						name:'审批',
						trigger: () => {
							this.popType = 15;
							// this.$refs.child.getPlanList();
						}
					}
				},
				// 订单状态
				orderStatus: {},
				detail: {
					title: {},
					permissions: [],
					order_info: {},
					design_info: {
						require_imgs: [],
						plan_imgs: [],
					},
					comment: [],
					invoice: {},
					order_logs: [],
					refused: {},
					refund_price: {},
				},
				detail_order_require_details: [],
				// 补充说明
				additionalNotes: '',
				// 补充说明文件
				additionalList: [],
				// 补充说明 数据
				additionalData: null,
				// // 单文件下载
				// fileName_i: "", // 下载提示
				// statusLoading: "down",
				// colorStatus: {
				//   down: "#f56c6c",
				//   bale: "#e60000",
				// },
				// // 显示下载 弹窗
				// dialogDownload: false,
				// // 当前是否有下载
				// is_currentDownload: false,
				// // 弹窗提示
				// downloadTextShow: "正在下载",
				// // 当前进度
				// pro_percentage: 0,
			};
		},
		beforeCreate() {},
		created() {},
		beforeMount() {},
		mounted() {
			this.id = window.atob(this.$route.query.id);
			this.getDetails();
		},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		methods: {
			// 补充说明文件  下载 所有
			downAllAdditional() {
				// 弹窗提示
				let dev_list = this.additionalList.filter((item) => {
					return item.raw;
				});
				if (dev_list.length > 0) {
					this.$confirm('有部分文件为本地文件，是否需要合并下载？', '系统提示', {})
						.then(() => {
							this.$downLoadDevLineZip(
								`补充说明文件`,
								this.additionalList,
								'download_url',
								'name',
								'file_exit'
							)
								.then(() => {
									this.isdownload = false;
								})
								.catch(() => {
									this.isdownload = false;
								});
						})
						.catch(() => {});
				} else {
					if (this.additionalList.length == 0) {
						return;
					}
					this.$downLoadDevLineZip(
						`补充说明文件`,
						this.additionalList,
						'download_url',
						'name',
						'file_exit'
					)
						.then(() => {
							this.isdownload = false;
						})
						.catch(() => {
							this.isdownload = false;
						});
				}
			},

			// 补充说明文件  下载
			downAdditional(file, file_title) {
				if (this.isdownload) {
					this.$message({
						message: `有文件正在下载`,
						showClose: true,
					});
					return;
				}

				if (this.clickAloneTimer) {
					clearTimeout(this.clickAloneTimer);
				}

				this.clickAllTimer = setTimeout(() => {
					if (file.raw) {
						this.$confirm('当前文件为本地文件，是否需要下载？', '系统提示', {
							confirmButtonText: '确认',
							cancelButtonText: '取消',
							type: 'warning',
						})
							.then(() => {
								FileSaver.saveAs(file.raw, `${file_title}`);
							})
							.catch(() => {});
						return;
					}
					this.isdownload = true;
					this.$refs['singleFileDownload']
						.downloadItem(file, file_title)
						.then(() => {
							this.isdownload = false;
						})
						.catch(() => {
							this.isdownload = false;
						});
				}, 600);
			},

			// 补充说明文件 上传
			uploadAdditional(val, valList) {
				let lastSuffix = val.name.getSuffix();
				let allow = true;
				// 上传进度
				val.progress = 0;
				// 是否正在上传
				val.upping = false;

				// 不支持上传格式的文件
				if (!this.suffix_text.includes(lastSuffix)) {
					allow = false;
					this.$message.error(`不支持上传${lastSuffix}格式的文件`);
					return;
				}

				//已有同名文件
				// console.log(this.additionalList);
				if (
					this.additionalList.find((item) => {
						return item.name == val.name;
					})
				) {
					this.$message.error(`已有同名文件`);
					allow = false;
					return;
				}

				// 文件大于1G 不让上传
				if (val.size > 1024 ** 3) {
					allow = false;
					this.$message.error(`单个文件过大，请分多成多个文件上传`);
					return;
				}

				if (allow) {
					this.additionalList.push(val);
				}
			},
			// 补充说明文件 上传 之前
			onBeforeUploadAdditional() {},
			// 删除补充说明文件
			removeAdditional(index) {
				this.additionalList.splice(index, 1);
			},
			// 保存补充说明
			saveAdditional() {
				let timer = null;
				// 执行 保存请求
				const fn = async () => {
					let fileList = await this.uploadFile_filter();
					this.additionalList = fileList;
					// name: "形状 2.png"
					// size: 478
					// temporary_url: ""
					// url: ""
					$get_order_mi_add({
						order_id: this.id,
						content: this.additionalNotes,
						files: fileList.map((item) => {
							const { name, size, url } = item;
							return { name, size, url };
						}),
					})
						.then((res) => {
							this.getOrder_mi();
						})
						.catch((err) => {});
					//
					// console.log(this.additionalNotes);
					// console.log(fileList);
				};
				// 弹窗提示
				this.$confirm('是否确认补充说明无误', '系统提示', {
					confirmButtonText: '保存补充说明',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						// 防抖
						if (timer) {
							clearTimeout(timer);
						}
						timer = setTimeout(fn, 400);
					})
					.catch(() => {});
			},
			// 上传文件
			async uploadFile_filter() {
				// 已上传过
				let fileExists = [];
				// 准备上传
				let filePrepare = [];
				const loading = this.$loading({
					lock: true,
					// text: "有文件正在上传不可“保存草稿箱”与“确认下单”",
					text: '正在上传文件请耐心等待....',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
				});
				// 文件分类
				try {
					this.additionalList.forEach((item, index) => {
						if (typeof item.raw == 'object') {
							// 文件索引
							item.iw = index;
							filePrepare.push(item);
						} else {
							fileExists.push(item);
							item.iw = index;
							item.upping = false;
							item.progress = 100;
						}
					});
				} catch (error) {
					loading.close();
					this.$message({
						message: `上传的文件数据有误,请重新提交`,
						type: 'error',
						callback: () => {},
					});
				}
				// 整合 已上传的 文件 与 已系统有文件
				let result = await this.uploadFile_up(filePrepare);
				loading.close();
				if (result && result.length > 0) {
					return [...fileExists, ...result];
				} else {
					return fileExists;
				}
			},
			// 上传文件
			uploadFile_up(files) {
				try {
					return new Promise((resolve, reject) => {
						Promise.all(
							files.map((item, index) => {
								// 上传
								return this.uploadOnlySplit(
									item.raw,
									1024 * 1024 * 10,
									item.iw,
									(ing, i, total) => {
										let complete = parseInt((i / total) * 100);
										this.additionalList[item.iw].upping = true;
										this.additionalList[item.iw].progress = complete;
										this.$forceUpdate();
									}
								);
							})
						)
							.then((res) => {
								let result = [];
								res.forEach((item, index) => {
									if (item.data && item.code == 200) {
										result.push({
											name: files[index].name,
											size: files[index].size,
											url: item.data.url,
											temporary_url: item.data.temporary_url,
										});
									} else {
										this.$message({
											message: `${files[index].name}上传异常`,
											type: 'error',
											callback: () => {},
										});
									}
								});
								resolve(result);
							})
							.catch((err) => {
								reject([]);
							});
					});
				} catch (error) {
					this.$message({
						message: `上传的文件数据有误,请重新提交`,
						type: 'error',
						callback: () => {},
					});
				}
			},
			// 大文件上传
			async uploadOnlySplit(file, sliceLength = 1024 * 1024 * 10, turn, uploadCallback) {
				//大小分界值
				let cutoff_value = 1024 * 1024 * 20;

				if (file.size <= cutoff_value) {
					sliceLength = file.size;
				}

				// 请求标识符
				let uploadOn = await $uploadOnlySplitOn({
					file_name: file.name,
					size: file.size, // 文件总大小
					suffix: file.name.getSuffix(),
				});
				// 使用进一法，来确定分片的个数
				let total_number = Math.ceil(file.size / sliceLength);
				// 分片的初始位置
				let start = 0;
				// 分片的结束位置
				let end = sliceLength;
				// 这里为promise.all方法准备一个数组
				let requset_file = null;

				for (let i = 1; i <= total_number; i++) {
					// 这里开始分片，并且把每一个分片上传到服务器
					// File{}
					//[0,0,1,0,1,2,3,4,5,5,2]
					let blob = file.slice(start, end); // 得到一个分片
					let formData = await new FormData(); // 创建一个FormData对象，准备传送数据
					await formData.append('file', blob); // formData
					await formData.append('uploadId', uploadOn.data.uploadId); // 同时为这个分片设置一个名称，其中的i帮助后端进行排序处理
					// formData组装好之后，调用pro()函数，返回一个promise对象，并把它放入parr数组中，方便后面的promise.all方法使用
					await formData.append('OSS_SEEK_TO', start);
					await formData.append('OSS_LENGTH', end);
					await formData.append('batch', i);
					if (i == total_number) {
						await formData.append('isuploadEnd', true);
					}
					start = end; // 调整下一个分片的起始位置
					end = start + sliceLength; // 调整下一个分片的结束位置
					if (end > file.size) {
						end = file.size; // 这里对最后的一个分片结束位置进行调整
					}

					// 打印 上传 formData数据
					// for (var value of formData.values()) {
					//   console.log(value);
					// }
					try {
						// 处理 并发问题 以及 传输顺序
						let result = await $uploadOnlySplitUpload({
							formData,
							onUploadProgress: (progressEvent) => {},
						});
						uploadCallback(null, i, total_number);
						result.dev_name = file.name;
						if (typeof result == 'object' && i == total_number && result.code == 200) {
							requset_file = result;
						}
					} catch (error) {}
				}
				return new Promise((resolve, reject) => {
					resolve(requset_file);
				});
			},
			finishCountDown() {
				window.location.reload();
				// this.$dialog.alert({
				//   title: '提示',
				//   message: '可支付',
				// }).then(() => {
				//   // on close
				// });
			},

			// 异常监听
			pdfError(error) {
				console.error(error);
			},
			// 1 重置数据  默认关闭窗口
			changParams(params) {
				switch (params.type) {
					case 1:
						this.getDetails();
						this.popType = 0;
						break;
					default:
						this.popType = 0;
					// this.closePop()
				}
			},
			onDownLoad(index) {
				// clickAloneTimer: null,
				// clickAllTimer: null,

				if (this.isdownload) {
					this.$message({
						message: `有文件正在下载`,
						showClose: true,
					});
					return;
				}

				if (this.clickAllTimer) {
					clearTimeout(this.clickAllTimer);
				}

				this.clickAllTimer = setTimeout(() => {
					clearTimeout(this.clickAllTimer);
					this.isdownload = true;
					if (index == 1) {
						let lists = [];
						let first = {};
						if (this.detail.design_info.require_imgs.length > 0) {
							lists = this.detail.design_info.require_imgs;
							first = {
								name: '提资图纸',
								next: {
									name: '交付图纸',
									list: this.detail.design_info.plan_imgs,
								},
							};
						} else if (this.detail.design_info.plan_imgs.length) {
							let plan_imgs = this.details.design_info.plan_imgs
								.map((item) => {
									return item.url;
								})
								.join(',');
							if (plan_imgs.length > 0) {
								lists = this.details.design_info.plan_imgs;
							} else {
								lists = [];
							}
						}

						if (lists.length >= 1) {
							this.$downLoadZip(
								`${this.detail.title.name}-${first.name}`,
								lists,
								'url',
								'name',
								'file_exit'
							)
								.then(() => {
									this.isdownload = false;
									if (first.next && first.next.list.length > 0) {
										this.isdownload = true;
										return this.$downLoadZip(
											`${this.detail.title.name}-交付图纸`,
											this.detail.design_info.plan_imgs,
											'url',
											'name',
											'file_exit'
										);
									}
								})
								.then(() => {
									this.isdownload = false;
								})
								.catch(() => {
									this.isdownload = false;
								});
						} else {
							this.isdownload = false;
							this.downloadItem(lists[0].url);
						}
						// for (let i = 0; i < this.detail.design_info.require_imgs.length; i++) {
						//   this.downloadItem(this.detail.design_info.require_imgs[i].url);
						// }
					} else {
						this.isdownload = false;
						// 下载发票
						this.downloadItem(this.detail.invoice.user_tax);
					}
				}, 1000);
			},
			//下载文件
			downloadItem(item) {
				// let url = window.URL.createObjectURL(new Blob([item]));
				// console.log(url);
				// let link = document.createElement("a");
				// link.style.display = "none";
				// link.href = url;
				// link.setAttribute("download", "发票.pdf");
				// // +'.pdf' 通过不同的后缀名下载不同的文件
				// //这里下载的是pdf格式的文件，拿到接口里的res也必须是pdf的文件流
				// document.body.appendChild(link);
				// link.click();
				let a = document.createElement('a');
				a.href = item;
				a.download = item;
				a.target = '_blank';
				a.click();
			},

			// 下载 文件
			downloadItem2(file, file_title) {
				if (this.isdownload) {
					this.$message({
						message: `有文件正在下载`,
						showClose: true,
					});
					return;
				}

				if (this.clickAloneTimer) {
					window.clearTimeout(this.clickAloneTimer);
				}
				this.clickAloneTimer = setTimeout(() => {
					this.isdownload = true;
					window.clearTimeout(this.clickAloneTimer);
					this.$refs['singleFileDownload']
						.downloadItem(file, file_title)
						.then(() => {
							this.isdownload = false;
						})
						.catch(() => {
							this.isdownload = false;
						});
				}, 1000);
			},
			// 获取 补充说明
			getOrder_mi() {
				$get_order_mi({
					order_id: this.id,
				}).then((res) => {
					this.additionalData = res.data;
					if (res.code == 200 && res.data) {
						this.additionalNotes = res.data.content || '';
						this.additionalList = res.data.files || [];
					}
				});
			},
			// 获取详情
			getDetails() {
				$orderOrderDetail({
					id: this.id, //"4544",
				}).then((res) => {
					if (res) {
						this.getOrder_mi();
						this.detail = res.data;
						this.detail_order_require_details = Object.keys(
							res.data.order_info.order_require_details
						).map((item) => {
							return {
								name: item,
								value: res.data.order_info.order_require_details[item].join(','),
							};
						});
						// console.log(this.detail_order_require_details);
						this.scoreStar = Number(res.data.comment.star);
						this.scoreStar7 = res.data.comment.star7?Number(res.data.comment.star7):0;
						this.scoreStar8 = res.data.comment.star8?Number(res.data.comment.star8):0;
						let item = {
							id: res.data.title.id,
							order_pro_name: res.data.title.name,
							crm_order_type: res.data.order_info.crm_order_type,
							crm_project_level: res.data.order_info.crm_project_level,
							crm_project_type: res.data.order_info.crm_project_type,
						};
						this.$refs.child.setSelectItem(item);
					}
				});
			},

			// 获取 权限
			// getTagPermissions() {
			//   // 获取 用户展示内容权限
			//   let permissions = this.$store.state.personalCenterPermissions.find(
			//     function check(val) {
			//       return val.name === "订单管理";
			//     }
			//   );
			//   this.permissions = permissions.children.map((item, index) => {
			//     let obj = {};
			//     obj[item.id] = item.name;
			//     return obj;
			//   });
			//   console.log(this.permissions);
			// },
		},
	};
</script>

<style lang="scss" scoped>
	.branch-container {
		counter-reset: section;
	}
	.branch-container.flex-direction {
		display: flex;
		flex-direction: column;
	}
	.small-title {
		box-sizing: border-box;
		padding: 18px 20px;
		font-size: 20px;
		font-weight: bold;
		line-height: 1;
		color: rgba(0, 0, 0, 1);
		background: rgba(255, 255, 255, 1);
		.breadcrumb {
			margin-bottom: 16px;
		}
	}
	.parma-shelf-info:last-child {
		margin-bottom: 0px;
	}
	.parma-shelf-info {
		margin-bottom: 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 14px;
		.parma-shelf-title {
			margin-right: 6px;
		}
		.parma-shelf-value.bold {
			font-weight: 600;
		}
		// .bold {
		//   font-weight: bold;
		// }
	}
	.order-details-parma {
		margin-top: 14px;
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		.details-parma-shelf {
			// border: 1px solid #000;
			margin-right: 36px;
			min-width: 220px;
			min-height: 80px;
			display: flex;
			color: #333333;
			flex-direction: column;
			justify-content: flex-end;
		}
	}
	.details-parma-btn.plain {
		border: 1px solid #e60000;
		color: #e60000;
		background: rgba(255, 255, 255, 1);
	}
	.details-parma-btn {
		margin-right: 12px;
		background: rgba(230, 50, 65, 1);
		color: #fff;
	}
	.btn-group {
		display: flex;
		align-items: center;
	}
	//审核不通过
	.audit-box {
		background-color: #fff;
		margin-bottom: 10px;
	}

	.failure-content {
		display: flex;
		justify-content: flex-start;
		padding: 24px 32px;
		img {
			width: 24px;
			height: 24px;
			margin-right: 12px;
		}
		h6 {
			font-size: 14px;

			font-weight: 400;
			line-height: 22px;
			color: #333333;
			margin-top: 10px;
		}
	}

	.check-infor {
		display: flex;
		justify-content: space-between;
		width: calc(var(--proportion) * 1000px);
	}
	.check-type {
		font-size: 16px;

		font-weight: bold;
		line-height: 22px;
		color: #333333;
	}
	.check-time {
		font-size: 12px;

		font-weight: 400;
		line-height: 22px;
		color: #999999;
		span {
			margin-right: 32px;
		}
	}
	.detail-content {
		box-sizing: border-box;
		width: 100%;
		padding: 18px 10px;
		display: flex;
		justify-content: flex-start;
		flex-grow: 1;
		.detail-content-left {
			margin: 0px 10px;
			margin-bottom: 10px;
			flex-grow: 1;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			min-height: 600px;
			.detail-content-info {
				margin-bottom: 20px;
				width: 100%;
				flex-grow: 1;
				min-height: 400px;
				background-color: #fff;
				border-radius: 2px;
			}
			.detail-pictrue-info {
				margin-bottom: 20px;
				width: 100%;
				min-height: 190px;
				background-color: #fff;
				border-radius: 2px;
			}
		}
		.detail-content-right {
			margin: 0px 10px;
			margin-bottom: 10px;
			flex-shrink: 0;
			min-width: 600px;
			max-height: 800px;
			min-height: 600px;
			border-radius: 2px;
			background-color: #fff;
		}
		.segmentation {
			display: flex;
			justify-content: flex-start;
		}
		.content-info-text {
			box-sizing: border-box;
			padding: 20px 36px;
			width: 100%;
			min-height: calc(100% - 55px);
			.info-text-group:last-child {
				margin-bottom: 0px;
			}
			.info-text-group.grouping {
				width: 50%;
			}
			.info-text-group {
				margin-bottom: 20px;
				.title {
					margin-bottom: 16px;
					font-size: 14px;

					font-weight: bold;
					color: #333333;
				}
			}
		}
	}
	.text-other {
		font-size: 14px;

		.text-item-cell:last-child {
			margin-right: 0px;
		}
		.text-item-cell {
			min-width: 250px;
			max-width: 100%;
			margin-right: 12px;
			margin-bottom: 10px;
			span {
				// margin-left: 10px;
				word-wrap: break-word;
				white-space: wrap;
			}
			.btn_box {
				margin-left: 8px;
				cursor: pointer;
				color: #e60000 !important;
				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
	.text-item {
		flex-shrink: 0;
		flex-grow: 1;
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		font-size: 14px;
		.text-item-cell:last-child {
			margin-right: 0px;
		}
		.text-item-cell {
			min-width: 250px;
			max-width: 100%;
			margin-right: 12px;
			margin-bottom: 10px;
			span {
				// margin-left: 10px;
				word-wrap: break-word;
			}
			.btn_box {
				margin-left: 8px;
				cursor: pointer;
				color: #e60000 !important;
				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
	.detail-content-title {
		position: relative;
		padding: 0px 36px;
		display: flex;
		align-items: center;
		height: 55px;
		border-bottom: 1px solid rgba(233, 233, 233, 1);
		font-size: 16px;

		font-weight: bold;
		color: #333333;
	}
	@media (max-width: 1280px) {
		.detail-content {
			flex-direction: column;
		}
		.timestamp-remark {
			width: 600px !important;
		}
	}
	.sementation {
		display: flex;
		justify-content: flex-start;
	}
	.score-shelf {
		width: 15%;
		max-width: 150px;
		flex-grow: 1;
		flex-shrink: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		.score-count {
			font-size: 14px;
			color: #333333;

			span {
				font-size: 14px;

				font-weight: bold;
				color: #333333;
			}
		}
		.score-star {
			display: flex;
			align-items: center;
			justify-content: center;
			// transform: scale(1.1);
			margin-bottom: 10px;
			.el-scorestar {
				position: relative;
				left: 2px;
			}
		}
	}
	.score-desc {
		margin-left: 20px;
		flex-grow: 1;
		max-width: 80%;
		flex-shrink: 0;
		.time {
			margin-bottom: 10px;
			font-size: 12px;

			font-weight: 400;
			line-height: 22px;
			color: #999999;
		}
		.content {
			font-size: 14px;

			font-weight: 400;
			line-height: 22px;
			color: #333333;
		}
	}
	.three-group {
		display: grid;
		grid-template-columns: 60% 40%;
		grid-gap: 10px;
		.three-group-item {
			// border: 1px solid #000;
		}
	}
	.timestamp::-webkit-scrollbar {
		width: 0px;
	}
	.timestamp {
		box-sizing: border-box;
		padding: 20px 36px 20px 180px;
		height: 100%;
		max-height: 710px;
		overflow-x: visible;
		overflow-y: scroll;
		scrollbar-width: none;
		::v-deep .el-timeline-item__timestamp.is-top {
			position: absolute;
			top: 0px;
			padding-top: 4px;
			left: -160px;
		}
		::v-deep .el-timeline-item__wrapper {
			min-height: 50px;
			box-sizing: border-box;
			padding: 0px 0px 20px 50px;
		}
		.timestamp-file,
		.timestamp-remark {
			padding: 14px 0px;
			width: 200px;
			color: #999999;
		}
		.timestamp-status {
			padding-top: 16px;
		}
		// .timestamp-status-1 {
		//   color: #12b142;
		// }
		// .timestamp-status-2 {
		//   color: #e60000;
		// }
	}
	.download-pictrue {
		position: absolute;
		top: 50%;
		right: 36px;
		transform: translateY(-50%);
		.down-btn {
			color: #fff;
			background-color: #e60000;
		}
	}
	::v-deep {
		// 面包屑
		.el-breadcrumb__inner {
			font-size: 14px;

			font-weight: 400;
			color: #999999 !important;
			&:hover {
				color: $theme-color !important;
			}
		}
	}

	.egress_time_address_box {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}
	.invoice-img {
		width: 300px;
		height: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow-y: auto;
		img {
			max-width: 100%;
			max-height: 100%;
		}
	}
	.refund-info {
		min-height: 100px !important;
	}

	.flex_box {
		display: flex;
		.p1 {
			margin-right: 5px;
		}
		.p2 {
			flex: 1;
			line-height: 1.5;
			word-break: break-all;
		}
	}
	.flex-between {
		display: flex;
		justify-content: space-between;

		.flex-shrink {
			flex-shrink: 0;
			min-width: 40%;
			max-width: 55%;
		}
	}
	.content-info-text {
		::v-deep {
			.el-timeline-item__content {
				max-width: 200px;
				word-wrap: break-all;
			}
		}
	}
	.w-100 {
		width: 100%;
	}
	.time-last {
		position: relative;
		margin-left: 6px;
		font-size: 13px;
		font-weight: 500;
		color: #999999;
		display: flex;
		align-items: center;
		::v-deep {
			.van-count-down {
				margin-right: 2px;
				color: #999999;
			}
		}
		span {
			position: relative;
			top: -0.5px;
			line-height: 20px;
		}
	}
	.top-margin {
		margin-top: 32px;
	}
	.form-input.address {
		min-height: 120px;

		::v-deep {
			.el-textarea__inner {
				min-width: 420px;
				max-width: 620px;
				height: 120px !important;
			}
		}
	}

	.additional-top-margin {
		margin-top: 32px;
	}
	.add-additional {
		cursor: pointer;
		font-size: 14px;
		font-weight: bold;
		color: #e60000;
		.add-icon {
			font-weight: 600;
		}
		&:active {
			opacity: 0.8;
		}
	}
	.additional-content {
		margin-top: 24px;

		.additional-item {
			margin-bottom: 12px;
			font-size: 14px;
			font-weight: 400;
			line-height: 22px;
			color: #333333;
			&::before {
				counter-increment: section;
				content: counter(section) '.';
			}
			span {
				cursor: pointer;
				margin-left: 20px;
				display: none;
				font-size: 14px;
				font-weight: 400;
				color: #e60000;
				&:active {
					opacity: 0.8;
				}
			}
			.name {
				display: inline-block;
				cursor: pointer;
				&:active {
					opacity: 0.7;
				}
			}
			&:hover {
				span {
					display: inline-block;
				}
			}
		}
	}
	.additional-btn {
		width: 80px;
		color: #fff;
		background-color: #e60000;
	}
</style>
